import React, { useState, useEffect, useRef } from "react";

export function InnModalPopup(props) {
  const [isClose, setisClose] = useState(false);
  const modalRef = useRef(null);

  // Function to handle click outside the modal
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setisClose(true);
      props.Onclose(false);  // Trigger the close callback
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCloseclick = () => {
    setisClose(!isClose);
    props.Onclose(false);
    //setisClose(!isClose);
  };

  const handleSaveclick = () => {
    props.OnSave();
  };

  const classNm = "agent-popup " + props.className;
  return (
    <div className="blue-modal-backdrop">
      <div className={classNm}>
        <button
          type="button"
          className="model-cls-btn-1"
          onClick={handleCloseclick}
        ></button>
        {/* <div className="popup-header">
            <div className="row g-0">
              <div className="col-6"><h3>Modal Name</h3></div>
              <div className="col-6 text-right">                
                <InnActionButton onClick={handleCloseclick}>Cancel</InnActionButton>                
                <InnPrimaryButton onClick={handleSaveclick}>Save</InnPrimaryButton>
              </div>
            </div>
          </div>
          <div className="popup-content">
            {props.children}
          </div> */}
          <div ref={modalRef}>
        {props.children}
        </div>
      </div>
    </div>
  );
}

